import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cream" data-id="element-150" data-mp="2ar2ea9wnokl1">
      <div className="max-w-2xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-151" data-mp="2oi7i7o723z16">
        <h2 id="pricing-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-152" data-mp="2jjcq1vn78y4e">
          Get The Complete System
        </h2>

        <div className="mt-8 rounded-3xl bg-white border-2 border-sage-soft shadow-card p-7 sm:p-10 text-center" data-id="element-153" data-mp="1rsycy1n0fpts">
          <p className="font-serif font-bold text-ink text-xl sm:text-2xl leading-snug" data-id="element-154" data-mp="25t96jcfpfiin">
            The Life Coach&apos;s Complete System
          </p>
          <p className="mt-2 text-ink-soft text-sm sm:text-base" data-id="element-155" data-mp="20vhfslqsq2g1">
            6 Tomes + 5 Bonuses — every stage of your client journey, done for
            you
          </p>

          <div className="mt-8 flex items-end justify-center gap-3" data-id="element-156" data-mp="3c81sbxzzr9hq">
            <span className="font-serif text-2xl text-ink-muted line-through" data-id="element-157" data-mp="3vyf6apizgw0s">
              $47
            </span>
            <span className="font-serif font-black text-6xl sm:text-7xl text-terracotta leading-none" data-id="element-158" data-mp="4rkqtmnj7p06">
              $27
            </span>
            <span className="text-sm font-semibold text-ink-muted pb-2" data-id="element-159" data-mp="erbm3qjx281b">USD</span>
          </div>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-160" data-mp="3d8z31ufwypgo">
            one-time · instant access
          </p>
          <p className="mt-4 text-xs sm:text-sm text-ink-muted" data-id="element-161" data-mp="3i81z4pdx1lci">
            The product will be charged in local currency
          </p>

          <CtaButton href="https://the-life-coach-s-complete-system.impultienda.ar/checkout" className="mt-3 w-full" data-id="element-162" data-mp="3n63plvdo8my0">
            YES, GIVE ME THE COMPLETE SYSTEM
          </CtaButton>

          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-ink-soft font-medium" data-id="element-163" data-mp="2uhy3b46yypw2">
            <li className="flex items-center gap-1.5" data-id="element-164" data-mp="2zf7rkgimgvib">
              <LockIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-165" data-mp="2rfjxninw4woq" />
              Secure checkout
            </li>
            <li className="flex items-center gap-1.5" data-id="element-166" data-mp="2mhi3a1l0laxy">
              <ZapIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-167" data-mp="316xrb9t5v29y" />
              Instant PDF download
            </li>
            <li className="flex items-center gap-1.5" data-id="element-168" data-mp="2w8w7unrtp0xy">
              <ShieldCheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-169" data-mp="28hqse9psoao6" />
              7-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}